import JILISLOTActions from './JILISLOTActions'

export default class TADASLOTActions extends JILISLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Fortune Gems',
      gameCode: 'TADA-SLOT-001',
      platform: 'TADA',
    }
  }
}
